import { NavLink } from "react-router";

import { Box, Divider, List, ListItem, ListItemButton, Stack, Typography } from "@mui/material";

import { TabSideNavigationProps } from "./TabSideNavigation.types";

export function TabSideNavigation({ items, activeKey }: TabSideNavigationProps) {
  return (
    <Stack flex={1} overflow="auto">
      <List disablePadding>
        {items.map((item) => {
          const isSelected = activeKey === item.key;

          return (
            <ListItem disablePadding key={item.key}>
              <Box width="100%">
                <ListItemButton
                  component={NavLink}
                  to={item.to}
                  selected={isSelected}
                  sx={{ p: 2, display: "flex", justifyContent: "space-between", gap: 1 }}
                >
                  <Typography
                    fontWeight={isSelected ? "bold" : "normal"}
                    color={isSelected ? "text.primary" : "text.secondary"}
                  >
                    {item.label}
                  </Typography>
                  {item.endAdornment}
                </ListItemButton>
                <Divider />
              </Box>
            </ListItem>
          );
        })}
      </List>
    </Stack>
  );
}
